import { useMemo } from 'react';
import { SuggestedLoadsSource } from 'shared/modules/load-suggestions/LoadSuggestionsDrawer';
import { useLoadSuggestions } from 'shared/modules/load-suggestions/data/LoadSuggestionsAPI';
import { OFFER_STATUSES } from '../../../carrier/offers/core/OffersStatusEnum';
import { OfferDetailsDTO } from '../../../carrier/offers/offers/data/OffersDTO';
import { usePostingsPageContext } from '../../../loadboard/core/postings/PostingsPageContext';
import { usePostingsCount } from '../../../loadboard/data/LoadboardPostingAPI';

const offerDetailsNudgingSourceMap: Partial<
  Record<(typeof OFFER_STATUSES)[number], SuggestedLoadsSource>
> = {
  declined: 'Declined Load Offer',
  accepted: 'Accepted Load Offer',
};

export const useLoadRequestSuggestionsNudging = () => {
  const {
    loadSuggestionsNudgingRequestedLoadGuid,
    setLoadSuggestionsNudgingRequestedLoadGuid,
  } = usePostingsPageContext();

  return {
    loadSuggestionsNudgingRequestedLoadGuid,
    setLoadSuggestionsNudgingRequestedLoadGuid,
  };
};

export const useLoadRequestSuggestionsNudgingLoadGuid = () => {
  const { loadSuggestionsNudgingRequestedLoadGuid } =
    useLoadRequestSuggestionsNudging();

  const { data: postingCounts } = usePostingsCount();

  return postingCounts?.suggested && postingCounts.suggested > 0
    ? loadSuggestionsNudgingRequestedLoadGuid
    : null;
};

interface OfferDetailsSuggestionsNudgingResult {
  isShown: boolean;
  source?: SuggestedLoadsSource;
}

export const useOfferDetailsSuggestionsNudging = (
  offerStatus?: OfferDetailsDTO['status'],
): OfferDetailsSuggestionsNudgingResult => {
  const { data: suggestedLoads = [] } = useLoadSuggestions([]);

  const unseenSuggestedLoadsCount = useMemo(() => {
    return suggestedLoads.filter((load) => !load.is_seen).length;
  }, [suggestedLoads]);

  const shouldShowSuggestedLoadsDeclineNudging =
    unseenSuggestedLoadsCount > 3 && offerStatus === 'declined';
  const shouldShowSuggestedLoadsAcceptNudging =
    unseenSuggestedLoadsCount > 3 && offerStatus === 'accepted';

  return {
    isShown:
      shouldShowSuggestedLoadsDeclineNudging ||
      shouldShowSuggestedLoadsAcceptNudging,
    source: offerStatus ? offerDetailsNudgingSourceMap[offerStatus] : undefined,
  };
};
